import { ReactComponent as Arrow } from '../assets/icon/Arrow.svg';
import { ReactComponent as Users } from '../assets/icon/Users.svg';
import { ReactComponent as GitBranch } from '../assets/icon/GitBranch.svg';
import { ReactComponent as CopyIcon } from '../assets/icon/CopyIcon.svg';
import { ReactComponent as Delete } from '../assets/icon/Delete.svg';
import { ReactComponent as Duplicate } from '../assets/icon/Duplicate.svg';
import { ReactComponent as Edit } from '../assets/icon/Edit.svg';
import { ReactComponent as Export } from '../assets/icon/Export.svg';
import { ReactComponent as Globe } from '../assets/icon/Globe.svg';
import { ReactComponent as LockSimple } from '../assets/icon/LockSimple.svg';
import { ReactComponent as Versions_Icon } from '../assets/icon/Versions_Icon.svg';
import './Card.css';
import DropdownMenuComponent from './DropdownMenuComponent';
import { exportYamlFile } from '../utilities/yamlExport';
import { fetchMyPromptDetails } from '../service/apiServices';
import { useAzureData } from '../context/AzureContext';
import { useNavigate } from 'react-router-dom';
import { usePromptLibraryContext } from '../context/PromptLibraryContext';
import { ToolTipFunction } from './inputField';
import { useLocation } from 'react-router-dom';
import { usePromptContext } from '../context/PromptContextType';
import PlainButton from './ButtonComponents';

type SavingsData = {
  author: string;
  currentVersion: string;
  description: string;
  title: string;
  totalVersions: number;
  tags: string[];
  is_new: boolean;
  promptID?: string;
  prompt_id?: string;
  is_prompt_type_private: boolean;
};

export default function CardView({
  isPromptLibrary,

  card,
  allPrompt,
  handleCopyButton,
  handleDeleteButton,
  handleVersionClick
}: {
  isPromptLibrary: boolean;
  card: SavingsData;
  allPrompt: boolean;
  handleCopyButton: () => void;
  handleDeleteButton: () => void;
  handleVersionClick: () => void;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { setMyPrompt } = usePromptContext();
  const { apiToken } = useAzureData();
  const handlePromptData = () => {
    try {
      fetchMyPromptDetails(card?.promptID, apiToken)?.then((data) => {
        const version = data?.meta?.currentVersion;
        // const dt = data?.promptsData[version - 1];
        const dt = data?.promptsData?.filter((itm) => itm?.prompt?.promptVersion === version);
        exportYamlFile(dt, `${dt?.prompt?.promptName}_Verion_${version}.yaml`);
      });
    } catch (error) {
      console.log(error);
      alert(error);
    }
  };

  const { getPromptDetails, setCodeView, setCodeViewPromptId } = usePromptLibraryContext();

  const myPromptDropDown = [
    {
      component: <Edit />,
      name: 'Edit',
      action: () => {
        navigate(`/addPrompt?promptId=${card?.promptID}`);
      }
    },
    {
      component: <Duplicate />,
      name: 'Duplicate',
      action: () => {
        handleCopyButton();
      }
    },
    { component: <Export />, name: 'Export as YAML', action: () => handlePromptData() },
    {
      component: <Delete />,
      name: 'Delete',
      action: () => {
        handleDeleteButton();
      }
    }
  ];

  const truncateText = (text: string, length: number) => {
    if (text?.length > length) {
      return text?.slice(0, length - 3) + '...';
    }
    return text;
  };

  const isPrivate = card?.is_prompt_type_private === 'private';
  const isPlaygroundCompare = location?.pathname === '/comparePrompts';
  const { promptsList, setPromptsList } = usePromptContext();

  const handleComparePromptAction = () => {
    const temp = [...promptsList];
    if (card?.promptID) {
      temp?.push(card?.promptID);
      setPromptsList(temp);
    }
  };

  const handleCardClick = () => {
    navigate(`/promptPlayground`);
    setMyPrompt(card?.promptID || '');
  };

  return (
    <div
      className="borderDetails cardParams p-2 h-100"
      style={{ overflow: 'hidden' }}
      onClick={() => (isPlaygroundCompare ? handleComparePromptAction() : handleCardClick())}>
      {card?.is_new && <div className="un_standard_color alignDataCenter newBox">New</div>}
      {isPromptLibrary && (
        <div>
          {allPrompt ? (
            <CopyIcon
              // style={{ cursor: 'pointer' }}
              className="rightSideIcon"
              onClick={(e) => {
                e.stopPropagation();
                handleCopyButton();
              }}
            />
          ) : (
            <DropdownMenuComponent options={myPromptDropDown} card={card} />
          )}
        </div>
      )}
      <div
        className="flexColumnSpaceBetween h-100"
        style={{
          minHeight: '100%',
          width: '100%'
        }}>
        {/* Header with Icon and Prompt Name*/}
        <div
          style={{
            display: 'flex',
            alignItems: 'center'
          }}>
          <div className="alignDataCenter cardIcon" style={{ marginRight: 10 }}>
            <Arrow style={{ width: '32px', height: '32px' }} />
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'Center'
            }}>
            <p style={{ color: '#0066CC', margin: 0 }} className="w400">
              {card?.title}
            </p>
            <div className="d-flex">
              <div
                className="h7_400 alignDataCenter background_blue borderDetails"
                style={{
                  width: '32px',
                  height: '19px',
                  borderRadius: '28px',
                  color: 'rgba(0, 134, 81, 1)',
                  padding: 0,
                  border: '1px solid rgba(0, 134, 81, 0.5)',
                  backgroundColor: 'rgba(0, 134, 81, 0.15)'
                }}>
                <p style={{ margin: 0, height: '100%' }}> V{card?.currentVersion}</p>
              </div>
              {!allPrompt && (
                <div
                  className="borderDetails alignDataCenter authorName h7_400"
                  style={{
                    width: '70px',
                    height: '19px',
                    border: `1px solid ${isPrivate ? 'rgba(119, 5, 188, 0.5)' : ''}`,
                    color: isPrivate ? 'rgba(119, 5, 188, 1)' : '',
                    backgroundColor: isPrivate ? 'rgba(119, 5, 188, .1)' : '',
                    marginLeft: '5px'
                  }}>
                  {isPrivate ? (
                    <LockSimple style={{ marginRight: 5 }} color="rgba(119, 5, 188, 1)" />
                  ) : (
                    <Globe style={{ marginRight: 5 }} />
                  )}

                  <p
                    style={{ margin: 0, height: '100%' }}
                    className="alignDataCenter"
                    data-toggle="tooltip"
                    data-placement="right"
                    title={card?.author}>
                    {isPrivate ? 'Private' : 'Public'}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Description of the Card */}
        <div style={{ margin: '10px 0', height: '100%' }}>
          <p style={{ color: 'var(--grey_tone)' }}>{truncateText(card?.description, 80)}</p>
        </div>
        {/* Other Details */}
        <div style={{ display: 'flex', gap: '8px' }}>
          <ToolTipFunction toolTipText={<>{card?.tags[0]}</>}>
            <div
              className="borderDetails alignDataCenter authorName "
              style={{
                width: '150px'
              }}>
              <p style={{ margin: 0, height: '100%' }} className="alignDataCenter">
                {truncateText(`BG: ${card?.tags[0]}`, 20)}
              </p>
            </div>
          </ToolTipFunction>
          <div
            className="borderDetails alignDataCenter authorName"
            style={{
              width: '151px'
            }}
            onClick={(e) => {
              e.stopPropagation();
              getPromptDetails(card?.promptID || '');
              handleVersionClick();
            }}>
            <GitBranch style={{ marginRight: 5 }} />
            <p style={{ margin: 0, height: '100%' }} className="alignDataCenter">
              Versions {card?.totalVersions}
              <span style={{ marginLeft: 5 }}>
                <Versions_Icon />
              </span>
            </p>
          </div>{' '}
          {isPromptLibrary && (
            <div
              className="borderDetails alignDataCenter authorName"
              style={{ width: '50px' }}
              onClick={(e) => {
                e.stopPropagation();
                setCodeView(true);

                // setting value of codeViewPrompt to differentiate between prompt specific click and general click
                setCodeViewPromptId(card?.promptID || '');
                getPromptDetails(card?.promptID || '');
              }}>
              <i className="bi bi-code-slash" style={{ fontSize: 20 }}></i>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
